import { render, staticRenderFns } from "./UserInviteSingle.vue?vue&type=template&id=e4332482&scoped=true"
import script from "./UserInviteSingle.vue?vue&type=script&lang=js"
export * from "./UserInviteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4332482",
  null
  
)

export default component.exports